module.exports = __webpack_public_path__ + "img/cloth_g3_sleeve-08.973bd6b1.svg";